module.exports = __webpack_public_path__ + "img/Logo24hrs.3aa8bd93.png";